import { Pipe, PipeTransform } from '@angular/core';
import { V9ParameterRow, V9ParameterRows } from '../../models/v9-parameter-row.model';

@Pipe({
  name: 'v9ReportParameterTabsFilter'
})
export class V9ReportParameterTabsFilterPipe implements PipeTransform {

  transform(chunkedParameters: V9ParameterRow[], tabName: string): any {
    const reportparameters = new V9ParameterRows();
    chunkedParameters.forEach(obj => {
      if (obj.Parameters.filter(x => x.TabName == tabName).length > 0) {
        const parameterRow = new V9ParameterRow();
        parameterRow.IncludeLineAtEndOfGroup = obj.IncludeLineAtEndOfGroup;
        parameterRow.IncludeLineAtStartOfGroup = obj.IncludeLineAtStartOfGroup;
        const parameters = obj.Parameters.filter(x => x.TabName == tabName);
        parameters.forEach(element => {
          parameterRow.Parameters.push(element);
        });
        reportparameters.Rows.push(parameterRow);
      }
    });
    return reportparameters.Rows;
  }
}
